import { inject } from '@angular/core';
import { CountriesStore } from '@app/state';

export const countriesInitializer = () => {
  const store = inject(CountriesStore);

  return () => {
    store.loadCountries();
  };
};
